import { FunctionComponent, lazy, Suspense, useEffect, useMemo, useRef, useState } from "react";
import { CorpoTable, Tabela, TabelaCabeca, TabelaCorpo, Tabler } from "../../../../components/formulario/tableStyled";
import LoadingGif from "../../../../components/loading";
import { useServicesCRM } from "../context/getCRM";

const Rows = lazy(() => import('./rows'))

interface TabelaListaEventosBatismoProps {

}

const TabelaListaCRM: FunctionComponent<TabelaListaEventosBatismoProps> = () => {

  const {  nextPagina } = useServicesCRM()

  const devRef = useRef<HTMLDivElement>(null);


  useEffect(() => {
    if (devRef.current) {
      devRef.current.addEventListener('scroll', (e: any) => {
        if (e.target?.scrollTop >= (e.target.scrollHeight - (e.target.clientHeight + 60))) {
          nextPagina()
        }
      })
    }
  }, [devRef])

  return (<>
        <Tabler>
          <Suspense fallback={<LoadingGif/>}>

            <CorpoTable ref={devRef}>
              <Tabela>
                <>
                  <TabelaCabeca>
                    <tr>
                      {
                        ['Id', 'Nome', 'Célula', 'Batismo', 'Checkin', 'Curso']?.map(
                          res => <th>{res}</th>
                        )
                      }
                    </tr>
                  </TabelaCabeca>
                  <TabelaCorpo >
                    <Rows />
                  </TabelaCorpo>
                </>
              </Tabela>
            </CorpoTable>
          </Suspense>
        </Tabler>

  </>);
}

export default TabelaListaCRM;
